const MOBILE_AUTH_UA =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;

export function isMobileAuthContext(): boolean {
  return MOBILE_AUTH_UA.test(navigator.userAgent);
}
